export default __webpack_public_path__ + "static/media/modalLogo.8d4d46ec.png";